<template>
    
</template>
<script>
import { MapeventBus } from "../../util/MapEventBus";
import {FollowTarget } from "../../store/EventBus/FollowTargetEB"
import { DeviceEventBus } from "../../DeviceEventBus";
import { surveillenceEventBus } from "../../util/surveillenceEventBus";

import _ from "lodash";
import * as turf from "@turf/turf";

import MapboxCircle from 'mapbox-gl-circle'
export default {
    data(){
        return {
           map: null, 
           active:false,
           activeID:undefined,    
           timer:undefined,
           marker:undefined,
           circle:undefined,    
           canvas:undefined,
           zoomLevel:undefined,
           acState: undefined ,
           circleRadius :0,
           circleRadiusConstant: 2000,
           debug:false
        }
    },
    methods:{
        start(data){
            try {
                let isNew = false
                
                if(this.active ){                    
                    if(this.debug) console.log("FollowTarget:start Stoping ", data)
                    this.stop()
                    if(this.activeID != data.id) isNew = true
                    this.active= false
                    this.activeID = undefined
                    this.acState = undefined
                    if(isNew) this.start(data)
                }else{
                    
                    let mapdata = this.$store.state.surveillance.surveillanceData
                    this.acState = mapdata.get(data.id).state
                    if(this.debug)console.log(this.acState)
                 
                    this.circle = new MapboxCircle({lat: this.acState.location.lat, lng: this.acState.location.lon}, this.circleRadius, {
                        editable: false,
                        // minRadius: 1609.34,
                        fillColor: '#29AB87'
                        })
                  
                    this.circle.addTo(this.map)
                    this.activeID = data.id
                    this.active= true
                   if(this.debug) console.log("FollowTarget:start ",this.activeID)
                    

                }
                   
            }catch (error) {
                console.log(error.message)
            }
            
        },
        stop(){
            try{
                if(this.debug)console.log("FollowTarget:stoping ", this.activeID)
                this.circle.remove()
                
                
            } catch (error) {
                console.log(error)
            }
            
        },
        
        update(){
          try {
              if(this.active && this.acState){
                if(this.debug)console.log("FollowTarget:update" +"  "+ this.activeID+"  "+ this.circle.getRadius())

                this.circle.setCenter ({lat: this.acState.location.lat, lng: this.acState.location.lon})
                if(this.debug) console.log("circleRadius 2 : "+this.circleRadius)
                this.circle.setRadius(this.circleRadius)
                
                this.map.setCenter([this.acState.location.lon, this.acState.location.lat])
             }
              
          }catch (error) {
              console.log(error)
          }   
             
        },
          updateAcState (){
             try {
               if (this.active)
               {
                    let mapdata = this.$store.state.surveillance.surveillanceData
                  if(mapdata.get(this.activeID))
                  {
                        this.acState = mapdata.get(this.activeID).state
                        if(this.acState) this.update()
                  }
                  
                 
               }
             }catch (error) {
                  this.start({id:this.activeID})
                 console.log(error)
             } 
            
          },
        updateRadius (){

            if( (this.zoomLevel >= 0) &&  (this.zoomLevel <= 7) ){
                if(this.debug)console.log(" between 5 & 7")
                this.circleRadius = this.circleRadiusConstant*12 
            }
            else if( (this.zoomLevel >= 7) &&  (this.zoomLevel <= 9) ){
                if(this.debug)console.log(" between 7 & 9")
                if(this.debug)this.circleRadius = this.circleRadiusConstant
            }else if((this.zoomLevel > 9) &&  (this.zoomLevel <= 11) ){
                if(this.debug)console.log(" between 9 & 11")
                this.circleRadius = this.circleRadiusConstant
            }else if((this.zoomLevel > 11) &&  (this.zoomLevel <= 13) ){
                if(this.debug)console.log(" between 11 & 12")
                this.circleRadius = this.circleRadiusConstant/3
            }else if((this.zoomLevel > 13) &&  (this.zoomLevel <= 15) ){
                if(this.debug)console.log(" between 13 & 15")
                this.circleRadius = this.circleRadiusConstant/100
            }else if((this.zoomLevel > 15) &&  (this.zoomLevel <= 17) ){
                if(this.debug)console.log(" between 15 & 17")
               this.circleRadius = this.circleRadiusConstant/100
            }
              if(this.debug)  console.log("circleRadius  : "+this.circleRadius)
        },     
    },
    mounted(){
        if(this.debug)console.log("followTarget Mounted");
    // this.$store.dispatch("surveillance/init")
        this.map = this.$store.getters["mapStore/getMap"];

         MapeventBus.$on("zoomend", () => {
            // console.log("followTarget:zoomend -> ",this.map.getZoom())
            this.zoomLevel= this.map.getZoom()
            if(this.debug)console.log("zoomLevel ",this.zoomLevel)
            this.updateRadius()
        });
         FollowTarget.$on("followTarget" , this.start)
         surveillenceEventBus.$on("UpdateSurveillanceData", this.updateAcState);
    },
    beforeDestroy(){
            surveillenceEventBus.$off("UpdateSurveillanceData", this.updateAcState);
    }

}
</script>


<style scoped>

</style>